import { render } from "./GmailRelativeMailsCommonViewer.vue?vue&type=template&id=16ac5250"
import script from "./GmailRelativeMailsCommonViewer.vue?vue&type=script&lang=js"
export * from "./GmailRelativeMailsCommonViewer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__